import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import ForgotPasswordForm from 'components/ForgotPasswordForm';
import { recoverPassword } from 'redux/actions/userActions';


const ForgotPassword = (props) => {
  const handleSubmit = async (formData) => {
    await props.recoverPassword({
      email: formData.email,
    });
  };

  return (
    <ForgotPasswordForm onFormSubmit={data => handleSubmit(data)} />
  );
};

ForgotPassword.propTypes = {
  recoverPassword: PropTypes.func.isRequired,
};

export default compose(connect(
  null,
  { recoverPassword },
))(ForgotPassword);
